import { Component } from '@angular/core';

@Component({
    selector: 'madero-terms',
    imports: [],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss'
})
export class TermsComponent {

}
